import { render, staticRenderFns } from "./OverrideTag.vue?vue&type=template&id=d4f992e4&scoped=true&"
import script from "./OverrideTag.vue?vue&type=script&lang=js&"
export * from "./OverrideTag.vue?vue&type=script&lang=js&"
import style0 from "./OverrideTag.vue?vue&type=style&index=0&id=d4f992e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f992e4",
  null
  
)

export default component.exports